import type {
  Locale,
  QueryModelType,
  SupportedCurrencies,
} from 'lc-services/types'

export const useSimilarHouses = (houseId: string) => {
  const { locale } = useI18n<unknown, Locale>()
  const { $lcServicesSearch } = useNuxtApp()
  const { searchController, searchPresenter } = $lcServicesSearch

  const initSimilarHouse = async ({
    booking,
    capacity = '1',
    currency,
    destinationIds = [],
    price = [0, 1000000],
  }: {
    booking?: { startDate: string | null; endDate: string | null }
    capacity?: string
    currency: SupportedCurrencies
    destinationIds?: string[]
    price?: [number, number]
    privateToken?: ''
  }) => {
    const searchHousesPayload: QueryModelType = {
      bathrooms: '1',
      bedrooms: '1',
      capacity,
      destinationIds,
      initializelist: true,
      itemsPerPage: 9,
      page: 0,
      prices: price,
      replica: 'recommended' as const,
      ...(booking?.startDate && booking?.endDate
        ? {
            period: {
              startDate: booking.startDate,
              endDate: booking.endDate,
            },
          }
        : null),
    }

    const { algoliaIds } = useAuth()
    await searchController.searchHousesV2(
      searchHousesPayload,
      locale.value,
      currency,
      algoliaIds.value,
      'web',
    )

    return (searchPresenter.vm.searchHousesResult ?? [])
      .filter((h) => Number(h.id) !== Number(houseId))
      .map((house) => ({
        ...house,
        averagePrice:
          (house.min_week_price[currency] + house.max_week_price[currency]) / 2,
      }))
  }

  return {
    initSimilarHouse,
  }
}
